import { render, staticRenderFns } from "./brandPolicy.vue?vue&type=template&id=1cec1de5"
import script from "./brandPolicy.vue?vue&type=script&lang=js"
export * from "./brandPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports